<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ $t('invoice.mainProgram') }}</label>
          <a-select
            v-model="apcId"
            :loading="loading"
            :options="apcList"
            class="ts-w-full"
            @change="onMainChange(apcId)"
          ></a-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ $t('invoice.subProgram') }}</label>
          <a-select
            v-model="apcsId"
            mode="multiple"
            :loading="loading"
            :options="subProgramOptions"
            class="ts-w-full"
          ></a-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'mainProgramSelectBox',
  data() {
    return {
      loading: false,
      subProgramOptions: null
    }
  },
  async created() {
    this.loading = true
    await this.getMainProgram().finally(() => (this.loading = false))
  },
  computed: {
    apcId: {
      get() {
        return this.$store.state.invoice.acp_id
      },
      set(newValue) {
        this.$store.commit('invoice/SET_APC_ID', newValue)
      }
    },
    apcsId: {
      get() {
        return this.$store.state.invoice.acps_id
      },
      set(newValue) {
        this.$store.commit('invoice/SET_APCS_ID', newValue)
      }
    },
    apcList() {
      return this.$store.state.invoice.mainPrograms.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    }
  },
  methods: {
    ...mapActions('invoice', ['getMainProgram']),
    onMainChange(apcId) {
      this.subProgramOptions = null
      this.$store
        .dispatch('invoice/fetchSubProgram', { acp_id: apcId })
        .then(response => {
          this.subProgramOptions = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    apcId: function() {
      this.$emit('fetch')
    },
    apcsId: function() {
      this.$emit('fetch')
    }
  }
}
</script>
